import React, { useCallback, useContext } from 'react';
import { PlayerUIContext, toggleModal } from '@24i/player-ui';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { StyledIcon as PlayerIcon } from '../../../Icons';
import { Button, Label } from './styled';
const RenderDefaultIcon = (buttonIconName, disabled, backgroundColor, styles) => (React.createElement(PlayerIcon, { style: Object.assign(Object.assign({}, styles.icon), { opacity: disabled ? 0.4 : 1 }), name: buttonIconName, className: "ModalTriggeringButton-Icon", "data-test": "ModalTriggeringButton-Icon", backgroundColor }));
export const ModalTriggeringButton = ({ buttonIconName, associatedModalType, className = '', backgroundColor = 'transparent', customIcon = RenderDefaultIcon, disabled, styles = {
    button: null,
    icon: null,
}, children, testID, shouldHide, }) => {
    const { dispatch } = useContext(PlayerUIContext);
    const onClick = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(toggleModal(associatedModalType));
    }, []);
    const { theme } = useTheme();
    const idName = String(children).split(' ').join('_').toLowerCase();
    if (shouldHide)
        return null;
    return (React.createElement(Button, { backgroundColor, disabled, onClick, style: styles.button, className: `ModalTriggeringButton ${className}`, "data-test": "ModalTriggeringButton", testID: testID !== null && testID !== void 0 ? testID : `${idName}_button`, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        } },
        customIcon(buttonIconName, disabled, backgroundColor, styles),
        children && (React.createElement(Label, { theme: theme, style: Object.assign({}, getFont(theme, 'h5')) }, children))));
};
//# sourceMappingURL=index.js.map